import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=c873bee2&scoped=true"
import script from "./edit.vue?vue&type=script&lang=js"
export * from "./edit.vue?vue&type=script&lang=js"
import style0 from "./edit.vue?vue&type=style&index=0&id=c873bee2&prod&lang=scss&scoped=scoped"
import style1 from "./edit.vue?vue&type=style&index=1&id=c873bee2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c873bee2",
  null
  
)

export default component.exports